<template>
  <div class="aigc_wrap">
    <div class="aigc_banner">
      <div class="banner_content">
        <div class="left">
          <div class="left_title">爱设计AIGC解决方案</div>
          <div class="left_info">更快<span class="blue_bold">速度</span>，更高<span class="blue_bold">产能</span></div>
          <div class="left_desc">10余款AIGC工具，围绕企业内容工作流，高效满足工作中的 PPT 、文案、H5、平面/视频制作等高质量内容的创作需求</div>
          <el-button class="left_button" @click="goContact">联系我们</el-button>
        </div>
        <div class="right">
          <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/banner/banner.png" alt="">
        </div>
      </div>
    </div>
    <div class="aigc_main">
      <div class="ai_list">
        <div class="ai_tool">
          <div class="tool_swiper">
            <div class="tool_nav">
              <div v-for="item in toolNav" :key="item.id" class="nav_item" :style="{opacity: item.id === currentId ? '1' : '0.5'}" @mouseenter="handleSwiper(item)">
                <span class="tool_icon"><img :src="item.icon" alt=""></span>
                <span class="tool_text">{{ item.text }}</span>
              </div>
            </div>
            <div class="swiper_content">
              <div class="swiper_item" :style="{top: (img.id === currentId) ? '0' : '100%', opacity: (img.id === currentId) ? '1' : '0'}" v-for="img in toolPics" :key="img.id">
                <img :src="img.url" alt="">
              </div>
            </div>
          </div>
          <div class="tool_content">
            <div class="content_title">
              <span class="order">01</span>
              <div class="text">AIGC生产力工具</div>
            </div>
            <div class="content_desc">爱设计整合丰富的 AIGC 技术和多模态的内容，提供文生文、文生图、图生图、图生视频AIGC创作工具，颠覆内容生产力。</div>
            <ul class="tool_list">
              <li>文生文：小红书/公众号/短视频脚本等智能文案生成</li>
              <li>文生图：文生图/文生海报/海报快速编辑等</li>
              <li>图生图：商品场景图/人物换装/智能延展/批量套版等</li>
              <li>图生视频：商品链接生成视频/视频换脸/视频抠图等</li>
            </ul>
            <div class="custom_talk" @click="goContact">企业咨询<i class="el-icon-right"></i></div>
          </div>
        </div>
        <div class="ai_ppt">
          <div class="ppt_content">
            <div class="content_title">
              <span class="order">02</span>
              <div class="text aipptLogo">
                <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/aipptLogo.png" alt="">
              </div>
            </div>
            <ul class="ppt_list">
              <li>AI一键生成PPT，让PPT设计不再难；</li>
              <li>文档秒变PPT，让PPT制作极速起飞；</li>
              <li>一键更换模板，轻松实现PPT“换装”；</li>
              <li>整体配色一键切换，色彩更换高效便捷；</li>
              <li>原创设计，严格把关素材版权，使用无忧；</li>
              <li>PPT在线编辑新体验，熟悉的PPT界面，更友好的编辑体验。</li>
            </ul>
            <div class="custom_talk" @click="goContact">企业咨询<i class="el-icon-right"></i></div>
          </div>
          <div class="ppt_video">
            <video src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIPPT.mp4" controls autoplay muted loop controlslist="nodownload"></video>
          </div>
        </div>
        <div class="ai_create">
          <div class="create_image">
            <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCServe.png" alt="">
          </div>
          <div class="create_content">
            <div class="content_title">
              <span class="order">03</span>
              <div class="text">AIGC创作服务</div>
            </div>
            <ul class="create_list">
              <li>提供AI平面创作，插画、KV、海报等。</li>
            </ul>
            <div class="content_desc">专业服务团队，为KA企业客户提供交付保障，全程由专业广告创意内容团队提供服务，无门槛壁垒，无障碍降本增效。</div>
            <div class="custom_talk" @click="goContact">企业咨询<i class="el-icon-right"></i></div>
          </div>
        </div>
      </div>
      <div class="plan_case">
        <div class="plan_content">
          <div class="plan_title">平面案例</div>
          <div class="plan_list">
            <div class="plan_item" v-for="plan in planList" :key="plan.id">
              <img :src="plan.url" alt="" @click="goPlanDetail(plan.id)">
              <div class="item_name">{{ plan.name }}</div>
              <div class="view_detail custom_talk" @click="goPlanDetail(plan.id)">查看详情<i class="el-icon-right"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="video_case">
        <div class="video_content">
          <div class="video_title">视频案例</div>
          <div class="video_wrap">
            <video src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/videoCase/AIVideo.m4v" controls autoplay muted loop controlslist="nodownload"></video>
          </div>
          <div class="video_name">项目：哪吒汽车AIGC视频创意</div>
          <div class="video_think">创作思路：根据哪吒GT汽车素材，结合AI视频生成玩法，AIGC融合制作产品宣传创意</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toolNav: [
        {
          id: 0,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_text2text_icon.png',
          text: '文生文'
        },
        {
          id: 1,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_text2pic_icon.png',
          text: '文生图'
        },
        {
          id: 2,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_pic2pic_icon.png',
          text: '图生图'
        },
        {
          id: 3,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_pic2video_icon.png',
          text: '图生视频'
        }
      ],
      toolPics: [
        {id: 0,url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_text2text.png'},
        {id: 1,url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_text2pic.png'},
        {id: 2,url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_pic2pic.png'},
        {id: 3,url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/content/AIGCTool/AIGCTool_pic2video.png'}
      ],
      currentId: 0,
      planList: [
        {
          id: 'taohuaji',
          name: '桃花姬比稿',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/taohuaji.png'
        },
        {
          id: 'ali',
          name: '阿里设计框比稿',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/ali.png'
        },
        {
          id: 'tengxun',
          name: '腾讯新闻眼界仲夏夜金句海报',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/tengxun.png'
        },
        {
          id: 'diantao',
          name: '点淘直播预热海报',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/diantao.png'
        },
        {
          id: 'sinian',
          name: '思念食品母亲节活动线上预热海报',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/sinian.png'
        },
        {
          id: 'kudi',
          name: '库迪咖啡新品上市产品海报',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/kudi.png'
        },
        {
          id: 'jd',
          name: '京东×LPL赛事比稿-官宣BD海报',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/jdLPL.png'
        },
        {
          id: 'lianjia',
          name: '链家代言人官宣比稿',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/planCase/lianjia.png'
        },
      ]
    }
  },
  mounted() {
    setInterval(()=>{
      if (this.currentId < 3) {
        this.currentId++
      } else {
        this.currentId = 0
      }
    }, 3000)
  },
  methods: {
    handleSwiper(item) {
      this.currentId = item.id
    },
    goContact() {
      const route = this.$router.resolve({ path: "/contact" });
      window.open(route.href, "_blank");
    },
    goPlanDetail(id) {
      const url = this.$router.resolve({
        path: '/planDetail',
        query: {
          id
        }
      })
      window.open(url.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.aigc_wrap {
  width: 100%;
  padding-top: 60px;
  .aigc_banner {
    width: 100%;
    height: 460px;
    background: linear-gradient(180deg, #02071F 0%, #061B58 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    .banner_content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        margin-right: 138px;
        .left_title {
          height: 67px;
          font-size: 48px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 67px;
          margin-bottom: 24px;
        }
        .left_info {
          height: 33px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 33px;
          margin-bottom: 16px;
          .blue_bold {
            color: #5A2DF5;
          }
        }
        .left_desc {
          width: 452px;
          height: 44px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, .8);
          line-height: 22px;
          margin-bottom: 40px;
        }
        .left_button {
          width: 126px;
          height: 44px;
          background: #5A2DF5;
          border-radius: 4px;
          border-color: #5A2DF5;
          color: #fff;
        }
      }
      .right {
        flex-shrink: 0;
        img {
          width: 582px;
          height: 408px;
          //object-fit: contain;
        }
      }
    }
  }
  .aigc_main {
    width: 100%;
    .ai_list {
      width: 100%;
      min-width: 1200px;
      padding: 72px 360px;
      background-color: #FBFBFB;
      .ai_tool {
        display: flex;
        justify-content: center;
        align-items: center;
        .tool_swiper {
          .tool_nav {
            display: flex;
            align-items: center;
            padding-left: 24px;
            .nav_item {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 17px;
              height: 22px;
              cursor: pointer;
              user-select: none;
              .tool_icon {
                width: 22px;
                height: 22px;
                margin-right: 8px;
              }
              .tool_text {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .swiper_content {
            width: 690px;
            height: 450px;
            margin-top: 24px;
            border-radius: 16px;
            overflow: hidden;
            position: relative;
            .swiper_item {
              width: 100%;
              height: 100%;
              background: #131519;
              border-radius: 16px;
              display: flex;
              align-items: center;
              position: absolute;
              transition: top 0.3s ease-in-out 0s, opacity 0.5s ease-in-out 0s;
              img {
                object-fit: contain;
              }
            }
          }

        }
        .tool_content {
          margin-left: 72px;
          .tool_list {
            width: 438px;
            height: 146px;
            background: #FFFFFF;
            box-shadow: 0px 18px 40px 0px rgba(0,0,0,0.1);
            border-radius: 8px;
            padding: 14px;
            margin-bottom: 32px;
            li {
              margin-bottom: 8px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3B3946;
              line-height: 22px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
      .ai_ppt {
        margin-top: 136px;
        display: flex;
        justify-content: center;
        align-items: center;
        .ppt_content {
          margin-right: 81px;
          .content_title {
            width: 234px;
            .order {
              background-color: #4D29E1;
            }
            .aipptLogo {
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #EDEAFC;
              img {
                width: 147px;
                height: 30px;
              }
            }
          }
          .ppt_list {
            width: 429px;
            color: #6E6C76;
            font-size: 14px;
            margin-bottom: 32px;
            li {
              margin-bottom: 8px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
        .ppt_video {
          width: 690px;
          height: 450px;
          background: #131519;
          border-radius: 16px;
          display: flex;
          align-items: center;
          video {
            width: 690px;
            height: 388px;
          }
        }
      }
      .ai_create {
        margin-top: 136px;
        display: flex;
        justify-content: center;
        align-items: center;
        .create_image {
          width: 690px;
          height: 450px;
          background: #131519;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 72px;
          flex-shrink: 0;
          img {
            width: 670px;
            height: 390px;
          }
        }
        .content_title {
          width: 292px;
          .order {
            background-color: #16733C;
          }
          .text {
            background-color: #E8F1EB;
          }
        }
        .create_list {
          margin-bottom: 8px;
          li {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
          }
        }
      }
      .content_title {
        width: 324px;
        height: 54px;
        background: #E7EDFA;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-radius: 12px;
        margin-bottom: 24px;
        .order {
          width: 54px;
          height: 54px;
          display: block;
          border-radius: 12px;
          background: #0D49CF;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 54px;
          text-align: center;
        }
        .text {
          flex: 1;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3B3946;
          line-height: 54px;
          text-align: center;
          border-radius: 12px;
        }
      }
      .content_desc {
        width: 438px;
        height: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6E6C76;
        line-height: 22px;
        margin-bottom: 32px;
      }
    }
    .plan_case {
      width: 100%;
      .plan_content {
        width: 100%;
        min-width: 1200px;
        padding: 72px 0;
        .plan_title {
          width: 100%;
          height: 45px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3B3946;
          line-height: 45px;
          margin-bottom: 40px;
          text-align: center;
        }
        .plan_list {
          width: 1200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          margin: 0 auto;
          .plan_item {
            width: 288px;
            height: 316px;
            background: #FFFFFF;
            border-radius: 16px;
            border: 1px solid #D9DEE8;
            margin-right: 16px;
            margin-bottom: 24px;
            flex-shrink: 0;
            padding: 16px 18px 17px 16px;
            transition: box-shadow .3s;
            position: relative;
            &:nth-child(4n){
              margin-right: 0;
            }
            &:nth-child(n + 5){
              margin-bottom: 0;
            }
            &:hover {
              box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.1);
              img {
                transform: scale(1.03);
              }
            }
            img {
              width: 100%;
              height: 200px;
              margin-bottom: 16px;
              transition: all .3s;
              cursor: pointer;
            }
            .item_name {
              height: 16px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3B3946;
              line-height: 16px;
            }
            .view_detail {
              position: absolute;
              left: 16px;
              bottom: 17px;
            }
          }
        }
      }
    }
    .video_case {
      width: 100%;
      height: 948px;
      background-image: url("https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIGC/videoCase/video_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .video_content {
        width: 100%;
        height: 100%;
        min-width: 1200px;
        padding: 72px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .video_title {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 45px;
          margin-bottom: 32px;
        }
        .video_wrap {
          width: 1140px;
          height: 648px;
          background: #000000;
          border-radius: 24px;
          margin-bottom: 24px;
          padding: 16px 0;
          video {
            width: 1140px;
            height: 616px;
          }
        }
        .video_name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 24px;
          margin-bottom: 8px;
        }
        .video_think {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 24px;
          color: rgba(255, 255, 255, .8);
        }
      }
    }
    .custom_talk {
      width: 75px;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5A2DF5;
      line-height: 22px;
      cursor: pointer;
      .el-icon-right {
        color: #5a2df5;
        margin-left: 5px;
      }
    }
  }
}
</style>
